(() => {
  const PARAM = 'item';

  const overlay = document.querySelector('[data-gallery-overlay]');
  const body = overlay?.querySelector('[data-gallery-overlay-body]');
  const grid = document.querySelector('[data-gallery-grid]');
  const closeBtn = overlay?.querySelector('[data-gallery-overlay-close]');

  if (!overlay || !body || !grid) return;

  let lastFocused = null;

  const openItem = (id, { updateHistory = true } = {}) => {
    const tile = grid.querySelector(`[data-gallery-item-id="${CSS.escape(id)}"]`);
    if (!tile) return false;

    const template = tile.querySelector('template[data-gallery-item-content]');
    if (!template) return false;

    body.replaceChildren(template.content.cloneNode(true));
    lastFocused = document.activeElement;

    if (typeof overlay.showModal === 'function') {
      overlay.showModal();
    } else {
      overlay.setAttribute('open', '');
    }

    if (updateHistory) {
      const url = new URL(window.location.href);
      url.searchParams.set(PARAM, id);
      window.history.pushState({ galleryItem: id }, '', url);
    }

    closeBtn?.focus({ preventScroll: true });
    return true;
  };

  const closeOverlay = ({ updateHistory = true } = {}) => {
    if (!overlay.open && !overlay.hasAttribute('open')) return;

    if (typeof overlay.close === 'function') {
      overlay.close();
    } else {
      overlay.removeAttribute('open');
    }
    body.replaceChildren();

    if (updateHistory) {
      const url = new URL(window.location.href);
      if (url.searchParams.has(PARAM)) {
        url.searchParams.delete(PARAM);
        window.history.pushState({}, '', url);
      }
    }

    if (lastFocused && typeof lastFocused.focus === 'function') {
      lastFocused.focus({ preventScroll: true });
    }
  };

  grid.addEventListener('click', (event) => {
    const tile = event.target.closest('[data-gallery-item-id]');
    if (!tile || !grid.contains(tile)) return;
    event.preventDefault();
    openItem(tile.dataset.galleryItemId);
  });

  closeBtn?.addEventListener('click', () => closeOverlay());

  overlay.addEventListener('click', (event) => {
    if (event.target === overlay) closeOverlay();
  });

  overlay.addEventListener('cancel', (event) => {
    event.preventDefault();
    closeOverlay();
  });

  window.addEventListener('popstate', () => {
    const id = new URL(window.location.href).searchParams.get(PARAM);
    if (id) {
      openItem(id, { updateHistory: false });
    } else {
      closeOverlay({ updateHistory: false });
    }
  });

  const initialId = new URL(window.location.href).searchParams.get(PARAM);
  if (initialId) {
    requestAnimationFrame(() => openItem(initialId, { updateHistory: false }));
  }
})();
